import { Downloader } from './downloader';

export class CSVReporter {
  static download(name: string, records: string[][]) {
    Downloader.download(name, records.map((e) => e.join(',')).join('\n'), 'data:text/csv;charset=utf-8');
  }
}
